import { useQuery } from '@tanstack/react-query';
import { getChatbotConfig } from '../../services/backendService';
import { ChatbotConfig } from '../../types/chatbotConfig.types';
import { ApiError } from '../../lib/api';
import { useConfigId } from '../../context/ConfigContext';

export const useConfig = () => {
  const { configId } = useConfigId();

  return useQuery<ChatbotConfig, ApiError>({
    queryKey: ['config', configId],
    queryFn: () => getChatbotConfig({ configId: configId! }),
    enabled: !!configId,
    staleTime: 1000 * 60 * 60,
  });
};
